const SongSubmissionView = require("./SongSubmissionView");
$(() => {
  $('.select-denomination').select2({
    placeholder: __('Choose One'),
    minimumResultsForSearch: Infinity
  });

  $('.select-state').select2({
    placeholder: __('Choose One')
  });

  $('.copyright-holder').select2({
    placeholder: __('Select Copyright')

  });

  $('.copyright-holder').change(function () {
    const select = $(this);
    const id = select.val();
    const name = select.find('option:selected').text();
    const alert = $('.alert-copyright');
    const submitBtn = $('.btn[name=submit]');

    $.post(checkIfEnabledForCopyright, {
      id
    }, (data) => {
      if (!data.enabled) {
        const text = `No additional ${name} song titles are covered under the ONE LICENSE license. Manual submissions cannot be entered for the ${name} catalog.`;

        select.parent().addClass('has-error');
        alert.show();
        alert.html(text);
        submitBtn.prop('disabled', true);
      } else {
        select.parent().removeClass('has-error');
        alert.hide();
        submitBtn.prop('disabled', false);
      }
    }, 'json');
  });

  const view = new SongSubmissionView();
  view.init();
});
